import React, { PropsWithChildren } from 'react'
import { AnimationName, Box } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/ThemeLottie'
import { LogoHeader } from 'components/header/LogoHeader'

export interface AppStatusProps extends PropsWithChildren {
  animationName: AnimationName
  title: string
}

export const AppStatus = ({ animationName, title, children }: AppStatusProps) => {
  return (
    <Box height="screen" width="full" flexCol>
      <LogoHeader hasPadding={false} />
      <Box paddingX={32} className="bg-surface-static h-full sm:px-[64px] md:px-[124px]">
        <Box height="full" flexCol justify="center" gap={32}>
          <Lottie src={animationName} />
          <Box flexCol gap={12} className="max-w-[600px] text-body-large text-foreground-prominent">
            <h1 className="text-h1">{title}</h1>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
